import { getApi } from 'common/modules/ReactShared/data/api';
import type {
  IFreeCoursesApiResponse,
  IFreeCoursesFetchResponse,
  IFreeCoursesParams,
  IExamLevelsResponse,
  IExamLevel,
  IExaminationResponse
} from './types';

export async function fetchFreeCourses(
  params?: IFreeCoursesParams
): Promise<IFreeCoursesFetchResponse> {
  const { data } = await getApi().get<IFreeCoursesApiResponse>('/exams', {
    params
  });

  return {
    records: data.exams,
    totalCount: data.totalCount,
    totalPages: data.totalPages,
    currentPage: data.currentPage
  };
}

export async function fetchExamLevels(): Promise<IExamLevel[]> {
  const { data } = await getApi().get<IExamLevelsResponse>('/exams/levels');
  return data.levels;
}

export async function registerForExam(examId: number): Promise<string> {
  const { data } = await getApi().post<IExaminationResponse>(
    `/exams/${examId}/examinations`
  );
  return data.examination.url;
}

export * from './types';
